import React, { RefObject } from "react";
import { useTranslation } from "react-i18next";
import Card from "../Card/Card";
import AboutUs from "../Services/AboutUs";
import ContactUs from "../Services/ContactUs";
import aboutUs from "../../images/aboutUs.jpg";
import type { Section } from "../../types/Section";
import { PageTitle } from "./HomeContent.styles";

export interface HomeContentProps {
  sections: Section[];
  isSmallScreen: boolean;
  aboutUsRef: RefObject<HTMLDivElement>;
  contactUsRef: RefObject<HTMLDivElement>;
}

const HomeContent: React.FC<HomeContentProps> = ({
  sections,
  isSmallScreen,
  aboutUsRef,
  contactUsRef,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t("home.title")}</PageTitle>
      {!isSmallScreen && (
        <Card
          cardRef={aboutUsRef}
          title={t("about-us.subject")}
          description={<AboutUs />}
          reverse
          image={aboutUs}
        />
      )}
      {sections.map((card, id) => (
        <Card
          key={card.subject}
          cardRef={card.ref}
          title={card.subject}
          description={card.description}
          reverse={id % 2 === 1}
          image={card.image}
          alt={card.alt}
        />
      ))}
      {!isSmallScreen && (
        <Card
          cardRef={contactUsRef}
          title={t("contact-us.subject")}
          description={<ContactUs />}
        />
      )}
    </>
  );
};

export default HomeContent;
